import {useState} from 'react';
import axios from 'axios';
import {
  Button,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  useToast,
  Flex,
  FlexProps,
  useDisclosure,
} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';
import {useGetMeQueryData, useMeQuery} from '@eksab/hooks';
import {AuthModal} from '@eksab/features/auth/modals/AuthModal';

import {useGiftCodeMutation} from '../hooks';

export function ApplyGiftCode(props: FlexProps) {
  const [code, setCode] = useState('');
  const toast = useToast();
  const authDisclosure = useDisclosure();

  const t = useTranslate();
  const giftCodeMutation = useGiftCodeMutation();
  const {data: me} = useMeQuery();
  const isUser = useGetMeQueryData();

  const applyGiftCode = () =>
    giftCodeMutation.mutate(code, {
      onSuccess: () => {
        toast({title: t('store.gift-code.success')});
        setCode('');
      },
      onError: (e) =>
        void toast({
          status: 'error',
          title:
            axios.isAxiosError(e) && e.response?.data.message ? e.response?.data.message : t('app.errors.try-again'),
        }),
    });

  const onAuthModalClose = () => {
    authDisclosure.onClose();

    if (isUser()) applyGiftCode();
  };

  const onCodeApply = () => {
    if (!me) return authDisclosure.onOpen();

    applyGiftCode();
  };

  return (
    <>
      <Flex flexDir="column" gap="2.5" {...props}>
        <Heading as="h2" size="lg" fontWeight="700">
          {t('store.gift-code.title')}
        </Heading>

        <InputGroup w={['full', null, '30rem']} borderRadius="sm" overflow="hidden">
          <Input
            fontSize={['md', 'sm']}
            fontWeight="500"
            borderRadius="inherit"
            placeholder={t('store.gift-code')}
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />

          <InputRightElement
            insetBlock="1px"
            insetEnd="1px"
            borderEndRadius="5px"
            bgColor={code ? 'green.400' : 'initial'}
            w="20"
            h="unset"
          >
            <Button
              borderRadius="inherit"
              fontSize="sm"
              fontWeight="700"
              h="full"
              disabled={!code}
              w="full"
              textTransform="capitalize"
              onClick={onCodeApply}
            >
              {t('profile.prizes.redeem')}
            </Button>
          </InputRightElement>
        </InputGroup>
      </Flex>

      <AuthModal {...authDisclosure} onClose={onAuthModalClose} route="login" />
    </>
  );
}
